import { useDimensions } from 'hooks/useDimensions';
import Logo from 'images/logo-v3.png';
import { MenuItem } from './styles';

import TwitterLogo from 'images/twitter.png';
import InstagramLogo from 'images/instagram.png';
import OpenseaLogo from 'images/opensea.png';
import RedditLogo from 'images/reddit.png';
import DiscordLogo from 'images/discord.png';
import { DISCORD_LINK, INSTAGRAM_LINK, OPENSEA_LINK, REDDIT_LINK, TWITTER_LINK } from 'CardCarousel/constants';
import { isTouch } from 'utils/isTouch';

const WrapperSocialIcons = () => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <img
      src={OpenseaLogo}
      width={20}
      style={{ marginRight: 10, cursor: 'pointer' }}
      onClick={() => {
        window.open(OPENSEA_LINK, '_blank');
      }}
      alt="opensea-logo"
    />
    <img
      src={InstagramLogo}
      width={18}
      style={{ marginRight: 10, cursor: 'pointer' }}
      onClick={() => {
        window.open(INSTAGRAM_LINK, isTouch ? null : '_blank');
      }}
      alt="instagram-logo"
    />
    <img
      src={TwitterLogo}
      width={20}
      style={{ marginRight: 10, cursor: 'pointer' }}
      onClick={() => {
        window.open(TWITTER_LINK, isTouch ? null : '_blank');
      }}
      alt="twitter-logo"
    />
    <img
      src={DiscordLogo}
      width={20}
      style={{ marginRight: 10, cursor: 'pointer' }}
      onClick={() => {
        window.open(DISCORD_LINK, isTouch ? null : '_blank');
      }}
      alt="discord-logo"
    />
    <img
      src={RedditLogo}
      width={20}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        window.open(REDDIT_LINK, isTouch ? null : '_blank');
      }}
      alt="reddit-logo"
    />
  </div>
);

export const Header = ({ onChangeContent }) => {
  const { isSmallWidth } = useDimensions();

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: isSmallWidth ? 'flex-start' : 'center',
          flexDirection: isSmallWidth ? 'column' : 'row',
          marginTop: isSmallWidth ? 50 : 100,
        }}
      >
        {!isSmallWidth && (
          <div style={{ marginTop: 4, marginRight: 20 }}>
            <WrapperSocialIcons />
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: isSmallWidth ? 'column' : 'row' }}>
          <MenuItem style={{ marginRight: isSmallWidth ? 10 : 20, fontWeight: 700, fontSize: 16 }} onClick={() => onChangeContent('home')}>
            HOME
          </MenuItem>
          <MenuItem style={{ fontWeight: 700, fontSize: 16 }} onClick={() => onChangeContent('about')}>
            ABOUT
          </MenuItem>
        </div>
        {isSmallWidth && (
          <div style={{ position: 'absolute', top: isSmallWidth ? 120 : 80, left: 5 }}>
            <WrapperSocialIcons />
          </div>
        )}
      </div>
      <img src={Logo} style={{ width: 200, height: 200, marginLeft: isSmallWidth ? 20 : 30 }} alt="logo" />
    </>
  );
};
